import React from "react";

import { PublicTicketTemplateShell } from "../../components/ticketTemplate/PublicTicketTemplateShell";
import { TicketTemplateCarousel } from "../../components/ticketTemplate/TicketTemplateCarousel";
import type { TicketTemplateId } from "../../types/rsvp";
import { DEFAULT_TICKET_TEMPLATE_CONFIG, TICKET_TEMPLATE_LABELS } from "../../types/rsvp";
import "../../components/ticketTemplate/ticketTemplate.css";

const CARD_WIDTH = 392;
const STATIC_SCALE = 0.55;

// Profile has no event, so the preview renders sample copy.
const SAMPLE_META = {
  event_name: "Your Event Name",
  event_date: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
  city: "Mumbai",
  artist: null,
  link_kind: "rsvp" as const,
  banner_url: null,
  lineup: [],
};

const TEMPLATE_HINTS: Record<TicketTemplateId, string> = {
  black: "Dark public signup",
  white: "Light public signup",
};

type Props = {
  templateId: TicketTemplateId;
  editing: boolean;
  onSelect: (id: TicketTemplateId) => void;
};

const DefaultTemplatePreview: React.FC<Props> = ({ templateId, editing, onSelect }) => (
  <div className="eventos-profile-template">
    {editing ? (
      <div className="eventos-profile-template-preview eventos-profile-template-preview--edit">
        <TicketTemplateCarousel
          templateId={templateId}
          config={DEFAULT_TICKET_TEMPLATE_CONFIG}
          meta={SAMPLE_META}
          onSelect={onSelect}
        />
      </div>
    ) : (
      <div
        className="eventos-profile-template-preview eventos-profile-template-preview--static"
        style={{ width: CARD_WIDTH * STATIC_SCALE }}
        inert
      >
        <div
          className="ticket-template-carousel__phone"
          style={{ width: CARD_WIDTH, transform: `scale(${STATIC_SCALE})`, transformOrigin: "top left" }}
        >
          <PublicTicketTemplateShell
            templateId={templateId}
            config={DEFAULT_TICKET_TEMPLATE_CONFIG}
            meta={SAMPLE_META}
            eyebrow="RSVP"
            previewMode
          />
        </div>
      </div>
    )}
    <div className="eventos-profile-template-caption">
      <span className="eventos-profile-asset-value">
        {TICKET_TEMPLATE_LABELS[templateId]} · {TEMPLATE_HINTS[templateId]}
      </span>
      {editing ? (
        <span className="eventos-subtle">Use the arrows or tap a side preview to switch, then Save.</span>
      ) : null}
    </div>
  </div>
);

export default DefaultTemplatePreview;
